import { Button, Grid, Paper, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { TotalResults } from "../product/TotalResults";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import { MenuList } from "../common/MenuList";
import { ProfileProductCard } from "../product/ProfileProductCard";
import { title } from "process";

interface IResultsWithFilterProps {
  menuItems: Array<{ label: string; value: string; isDisabled?: boolean }>;
  filterHandler: (event: string) => void;
  defaultValue: string;
  totalResults: number;
}
export const ResultsWithFilter: React.FC<IResultsWithFilterProps> = ({
  menuItems,
  filterHandler,
  defaultValue,
  totalResults,
}) => {
  return (
    <>
      {/* Total Results */}
      <Grid item>
        <span
          style={{
            color: "#666",
            fontWeight: "300",
            fontSize: "14px",
            verticalAlign: "middle",
          }}
        >
          <TotalResults quantity={totalResults} />
        </span>
      </Grid>

      {/* Tune Icon (properly aligned) */}
      <Grid item sx={{ display: "flex", alignItems: "center" }}>
        <TuneOutlinedIcon fontSize="small" />
      </Grid>

      {/* Filter Dropdown (properly aligned) */}
      <Grid item sx={{ display: "flex", alignItems: "center" }}>
        <MenuList
          menuItems={menuItems}
          filterHandler={filterHandler}
          defaultValue={defaultValue}
        />
      </Grid>
    </>
  );
};
